import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-select/dist/react-select.css';
import './css/index.scss';
import './css/featureflow.scss';
import './css/cosmo3.scss';

const rootEl = document.getElementById('root');

ReactDOM.render(
  <App />,
  rootEl
);

if (module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    console.clear();
    ReactDOM.render(
      <NextApp />,
      rootEl
    );
  });
}
